import React from 'react';
import {Link} from "react-router-dom";

import ListButton from './listButton.js'
import Pagination from './pagination.js'
import SectionHeader from './sectionHeader.js'
import TechnologyIconAndName from './technologyIconAndName.js'

import {_printNumber, _printPercent} from '../helpers/helpers.js'

import {CategoryTechnologies as RtCategoryTechnologies} from '../../../server/routes/route-types.js'

interface CategoryTechnologiesProps {
    categoryTechnologies: RtCategoryTechnologies | null;
    link?: string;
}

interface DomainCountChangeProps {
    domainCountChange: number;
}

export default function CategoryTechnologies({categoryTechnologies,link}: CategoryTechnologiesProps) {

	if (!categoryTechnologies) return null;

    return (
        <div className="row row-50">
            <div className="col-12">
                <SectionHeader header={categoryTechnologies.Header} link={link} anchor='toptech'/>
                <div className="table-outer table-rounded table-responsive-lg">
                    <table className="table-custom table-custom-striped table-custom-primary">
                        <thead>
                            <tr>
                                <th>
                                    Technology
                                </th>
                                <th>
                                    Websites
                                </th>
                                {
                                    categoryTechnologies.IsExclusive ?
                                    <th>
                                        Market Share
                                    </th>
                                    :
                                    <th>
                                        Market Penetration
                                    </th>
                                }
                                <th>
                                    Recent changes
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                categoryTechnologies.Technologies.map((topTechnology, indexKey) => {
                                    return (
                                        <tr  key={indexKey}>
                                            <td>
                                                <b>
                                                    <TechnologyIconAndName 
                                                        technology={topTechnology.TechnologyShortName}
                                                        technologyURL={topTechnology.TechnologyURL}
                                                        technologyIcon={topTechnology.TechnologyIcon}
                                                    />
                                                </b>
                                            </td>
                                            <td>
                                                <Link 
                                                        to={`/technology/${topTechnology.TechnologyURL}/websites`}
                                                        className="link-hover word-break" 
                                                        title={`Websites using ${topTechnology.TechnologyShortName}`}
                                                    >
                                                   <b>{_printNumber(topTechnology.DomainCount)}  </b>                            
                                                </Link>
                                            </td>
                                            <td><b>{_printPercent(topTechnology.MarketShare)}%</b> </td>
                                            <td>
                                                <Link 
                                                    to={`/technology/${topTechnology.TechnologyURL}/changes`}
                                                    className="link-hover word-break" 
                                                    title={`${topTechnology.TechnologyShortName} changes`}
                                                >
                                                    <DomainCountChange domainCountChange={topTechnology.DomainCountChange} />
                                                </Link>
                                            </td>
                                        </tr>                                
                                    )
                                })
                            }
                        </tbody>
                    </table>
                </div>                              
                <Pagination pages={categoryTechnologies.Pages} />
                <ListButton button={categoryTechnologies.Button} />  
            </div>                              
        </div>                              
    )    
}

function DomainCountChange({domainCountChange}: DomainCountChangeProps) {
    
    if (domainCountChange == 0) {
        return (<span className="icon"><b>+{_printNumber(domainCountChange)}</b></span>)
    }
    else if (domainCountChange > 0) {
        return (
            <span 
                className="icon" 
                style={{color: 'green'}}
            >
                    <b>+{_printNumber(domainCountChange)}
                    </b>
            </span>)
    }
    else {
        return (
            <span 
                className="icon" 
                style={{color: 'red'}}
            >
                <b>{_printNumber(domainCountChange)}
                </b>
            </span>)
    }
}
